import { render, staticRenderFns } from "./sendMsg.vue?vue&type=template&id=482ffaa2&scoped=true"
import script from "./sendMsg.vue?vue&type=script&lang=js"
export * from "./sendMsg.vue?vue&type=script&lang=js"
import style0 from "./sendMsg.vue?vue&type=style&index=0&id=482ffaa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ffaa2",
  null
  
)

export default component.exports